/** Extract team number from `Team N …` or `Team N *` Syncore strings. */
export function parseTeamNumber(syncoreRef: string): number | null {
  const match = /^Team (\d+)/i.exec(syncoreRef.trim());
  return match ? Number(match[1]) : null;
}

/** Canonical wildcard key on `teams.syncore_ref` and target `scope_key`. */
export function teamSyncoreWildcard(teamNumber: number): string {
  return `Team ${teamNumber} *`;
}
